/* eslint-disable no-unused-vars */
import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const materialCategories = [
  'Concrete & Cement',
  'Steel & Metals',
  'Timber & Wood',
  'Glass & Windows',
  'Electrical',
  'Plumbing',
  'Insulation',
  'Roofing',
  'Flooring',
  'HVAC',
  'Masonry',
  'Paint & Coatings',
  'Hardware & Fasteners',
  'Safety Equipment',
  'Tools & Machinery',
];

const MaterialSelector = ({ selectedMaterials, onToggleMaterial, error }) => {
  return (
    <View style={styles.formField}>
      <Text style={styles.fieldLabel}>
        Materials & Services
        <Text style={styles.requiredStar}> *</Text>
      </Text>
      <Text style={styles.fieldDescription}>
        Select all materials and services this supplier provides
      </Text>
      <View style={styles.materialGrid}>
        {materialCategories.map(material => (
          <TouchableOpacity
            key={material}
            style={[
              styles.materialChip,
              selectedMaterials.includes(material) &&
                styles.selectedMaterialChip,
            ]}
            onPress={() => onToggleMaterial(material)}
          >
            <Text
              style={[
                styles.materialChipText,
                selectedMaterials.includes(material) &&
                  styles.selectedMaterialChipText,
              ]}
            >
              {material}
            </Text>
            {selectedMaterials.includes(material) && (
              <Ionicons
                name="checkmark"
                size={16}
                color="#fff"
                style={styles.checkIcon}
              />
            )}
          </TouchableOpacity>
        ))}
      </View>
      {error && <Text style={styles.errorText}>{error}</Text>}
    </View>
  );
};

const styles = StyleSheet.create({
  formField: {
    marginBottom: 20,
  },
  fieldLabel: {
    fontSize: 16,
    fontWeight: '500',
    color: '#333',
    marginBottom: 8,
  },
  requiredStar: {
    color: '#e74c3c',
  },
  fieldDescription: {
    fontSize: 14,
    color: '#666',
    marginBottom: 10,
  },
  materialGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
  },
  materialChip: {
    backgroundColor: '#f8f9fa',
    borderWidth: 1,
    borderColor: '#ddd',
    borderRadius: 20,
    paddingHorizontal: 15,
    paddingVertical: 8,
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 5,
  },
  selectedMaterialChip: {
    backgroundColor: '#0e4e96',
    borderColor: '#0e4e96',
  },
  materialChipText: {
    fontSize: 14,
    color: '#333',
  },
  selectedMaterialChipText: {
    color: '#fff',
  },
  checkIcon: {
    marginLeft: 5,
  },
  errorText: {
    color: '#e74c3c',
    fontSize: 14,
    marginTop: 5,
  },
});

export default MaterialSelector;
